import { translate } from 'src/app/project/features/translate/translate';
import {
  EReminderFilterKeys,
  EReminderFilterType,
  TReminderFilterOptions,
} from '../reminder-filters.consts';

export function getReminderLinkedToOptions(): TReminderFilterOptions {
  return {
    type: EReminderFilterType.LINKED_TO,
    label: translate('linked_to_point'),
    options: [
      {
        label: translate('linked'),
        selected: true,
        value: EReminderFilterKeys.LINKED,
      },
      {
        label: translate('without_link'),
        selected: true,
        value: EReminderFilterKeys.WITHOUT_LINK,
      },
    ],
  };
}

export function getReminderStatusOptions(): TReminderFilterOptions {
  return {
    type: EReminderFilterType.STATUS,
    label: translate('status'),
    options: [
      {
        label: translate('upcoming'),
        selected: true,
        value: EReminderFilterKeys.UPCOMING,
      },
      {
        label: translate('dismissed'),
        selected: true,
        value: EReminderFilterKeys.DISMISSED,
      },
      {
        label: translate('overdue'),
        selected: true,
        value: EReminderFilterKeys.OVERDUE,
      },
    ],
  };
}

export function getReminderTypeOptions(): TReminderFilterOptions {
  return {
    type: EReminderFilterType.TYPE,
    label: translate('type'),
    options: [
      {
        label: translate('shared_by_me'),
        selected: true,
        value: EReminderFilterKeys.SHARED_BY_ME,
      },
      {
        label: translate('shared_with_me'),
        selected: true,
        value: EReminderFilterKeys.SHARED_WITH_ME,
      },
      {
        label: translate('personal'),
        selected: true,
        value: EReminderFilterKeys.PERSONAL,
      },
    ],
  };
}
